import React, { useCallback, useEffect, useState } from "react";
import { Button, Form, Row, Col, Alert, Switch } from "antd";
import { FieldTypes, generateFormFields } from "utils/formUtils";

export const excludePrefix = "Exclude - ";
const ColumnFilterSearchBoxWithExclude = ({
  clearFilters,
  message,
  inputProps,
  setSelectedKeys,
  confirm,
  selectedKeys,
  visible,
  hideExcludeSwitch = false
}) => {
  const [form] = Form.useForm();
  const hasExcludeKeyword = selectedKeys[0] ? selectedKeys[0].indexOf(excludePrefix) !== -1 : false;
  const [exclude, setExclude] = useState(() => hasExcludeKeyword);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    if (visible) {
      setExclude(hasExcludeKeyword);
      setChanged(false);
      form.setFieldsValue({
        inputValue: hasExcludeKeyword ? selectedKeys[0]?.split(excludePrefix).pop() : selectedKeys[0]
      })
    }
  }, [form, hasExcludeKeyword, selectedKeys, visible])

  const applyFilter = useCallback(async () => {
    await form.validateFields();
    const data = await form.getFieldsValue();
    setSelectedKeys(exclude ? [`${excludePrefix}${data.inputValue}`] : [data.inputValue]);
    confirm();
  }, [confirm, exclude, form, setSelectedKeys]);

  const clearFilter = () => {
    clearFilters();
  }

  const fields = [{
    name: 'inputValue',
    placeholder: " ",
    label: '',
    colSpan: 24,
    type: FieldTypes.ANTD_DEFAULT_INPUT,
    ...inputProps,
    props: {
      autoFocus: true
    }
  }];

  return (
    <div className="column-filter" style={{ width: 332 }}>
      <div className="p-xs">
        {message && <Row>
          <Col span={24} className='m-b-xs'>
            <Alert type="info" description={message} />
          </Col>
        </Row>}
        <Form initialValues={{
          inputValue: hasExcludeKeyword ? selectedKeys[0]?.split(excludePrefix).pop() : selectedKeys[0]
        }} layout="vertical" name="column-fiter" form={form} onValuesChange={() => setChanged(true)}>
          {generateFormFields(fields)}
        </Form>
        {
          hideExcludeSwitch
          ?
          null
          :
          <>
            <Switch className="m-r-xs" title="Exclude" size="small" checked={exclude} onChange={(e) => {
              setExclude(e);
              setChanged(true);
            }} />
            Exclude
          </>
        }
      </div>
      <div className="ant-table-filter-dropdown-btns">
        <Button size="small" type="link" onClick={clearFilter}>
          Clear
        </Button>
        <Button type="primary" size="small" onClick={applyFilter} disabled={!changed}>
          Apply
        </Button>
      </div>
    </div>
  );
};

export default ColumnFilterSearchBoxWithExclude;
